import React from 'react'
import { AUTH_PERMISSION_KEYS } from 'constants/auth-permission-keys'
import type { Locale } from 'date-fns'
import useFavurTranslation from 'hooks/useFavurTranslation'
import useRolesViews from 'hooks/useRolesViews'
import usePastMonthWtc from 'pages/Tasks/MonthlySheet/Details/usePastMonthWtc'
import type { MonthlySheetTaskT, TaskT } from 'pages/Tasks/types'
import TaskDetailsHeader from 'redesign/components/organisms/headers/task-details-header'
import { TASK_DETAILS_PAGE_ROOT_ID } from 'redesign/pages/task-details/constants'
import type { Task } from 'shared/graphql/graphql'
import Page from '../Page'
import { getActionButtons } from '../task-details-action-buttons/utils/get-action-buttons'
import { TASK_TYPE_TITLE } from '../task-details/constants'
import type { TaskDetailsProps, TaskTypeKey } from '../task-details/types'
import Timeline from '../timeline'
import { createTimeline } from '../timeline/factory/timeline-factory'

const MonthlySheetDetails: React.FC<TaskDetailsProps> = ({ task, refetch }) => {
  const { t, locale } = useFavurTranslation()
  const { personIds, isOffice } = useRolesViews()
  const { prevMonthTask } = usePastMonthWtc({ currentMonthTask: task as TaskT<MonthlySheetTaskT> })

  const timelineItems = createTimeline({
    task,
    t,
    locale: locale as Locale,
    personIds,
    isOffice,
  })

  return (
    <Page
      hideNativeNavigation
      rootId={TASK_DETAILS_PAGE_ROOT_ID}
      header={<TaskDetailsHeader title={t(TASK_TYPE_TITLE[task.taskType as TaskTypeKey])} />}
      footer={getActionButtons({
        task,
        refetch,
        workflowPermissions: AUTH_PERMISSION_KEYS.workflowMonthlySheets,
        prevMonthTask: prevMonthTask as Task,
      })}
    >
      <Timeline items={timelineItems} isOffice={isOffice} />
    </Page>
  )
}

export default MonthlySheetDetails
